<template>
<section class="view-wrap">
  <div class="container full-width">
    <div class="row no-padding row-wrap">
     <!-- {{ displayNodes }} -->
   
     <div class="column column-100 no-padding">
        <div class="header-spacer"></div>
        <!-- <h2>TRAIL MAP</h2> -->
        <div v-if="info.search">
          <div v-if="info.search.length > 0">
            <TrailMap :mapFilter="info.search" :trailDesc="true" :searchGroups='info.search_groups' :colorKey='info.colorKey' :pageID='info.id' />
            <!-- <SearchGroupsBlock :searchGroups='info.search_groups'/> -->
          </div>
        </div>
     </div>
    </div>
  </div>
</section>
</template>

<script>
// import TopMenu from '@/components/TopMenu.vue'
import axios from 'axios'
import NodeInfo from '@/components/NodeInfo.vue'
import RelatedItems from '@/components/RelatedItems.vue'
import BasicMap from '@/components/BasicMap.vue'
import TrailMap from '@/components/TrailMap.vue'
import SearchGroupsBlock from '@/components/SearchGroupsBlock.vue'
export default{
  name: 'mappage',
  data(){
    return{
      info:[]
    }
  },
  components: {
    NodeInfo,
    RelatedItems,
    BasicMap,
    TrailMap,
    SearchGroupsBlock,
  },
  watch:{
    // $route (to, from){
    //   if (to.path.startsWith(from.path)) {
    //     this.routeCheck = "It came from the parent directly"
    //   } else {
    //     this.routeCheck = "It came from someplace else"
    //   }
    //   // print("Does it end with -slide: ", to.name.endsWith('-slide'))
    //   // if (!to.name.endsWith('-slide')){
    //   this.fetchData().then(data =>{
    //     this.info = data
    //   })
    //   // } else {
    //   //   console.log("Dont FIRE!")
    //   // }
    // }
  },
  computed: {
    contentWidth: function() {
      if (this.info.address) {
        return 'column-50';
      }
      return 'column-100';
    },
    displayNodes: function() {
      var nodes = this.info.node
      // nodes = nodes.filter(n => { return n.path.length > 4 })
      var nodeSections = []
      for (var node in nodes) {
        // Last and -> only include direct children of the node
        var tempChildNodes = nodes.filter(n => { return n.path.startsWith(nodes[node].path) && n.path !== nodes[node].path && n.path.length === (nodes[node].path.length + 4) })
        var childNodes = []
        for (var n in tempChildNodes) {
          childNodes.push(tempChildNodes[n].name);
        }
        nodeSections.push({'node': nodes[node].name, 'child_nodes': childNodes})
      }
      nodeSections = nodeSections.filter(n => { return n.child_nodes.length > 0 })
      for (var node in nodeSections) {
        for (var chil in nodeSections[node].child_nodes) {
          for (var x in nodeSections){
            if (nodeSections[node].child_nodes[chil] == nodeSections[x].node) {
              nodeSections[node].child_nodes.splice(chil, 1)
            }
          }
        }
      }
      nodeSections = nodeSections.filter(n => { return n.child_nodes.length > 0 })
      return nodeSections
    }
  },
  // created (){
  //   console.log("Createing component")
  //   this.fetchData().then(data =>{
  //     // console.log('INFO: ',data.search)
  //     this.info = data
  //     if (this.info.custom_styles) {
  //       let styles = document.createElement('style');
  //       styles.type = 'text/css';
  //       styles.id = 'temp-styles';
  //       for (let d in this.info.custom_styles) {
  //         if (!this.info.custom_styles[d].value.hide) {
  //           styles.appendChild(document.createTextNode(this.info.custom_styles[d].value.style));
  //         }
  //       }
  //       document.getElementsByTagName("head")[0].appendChild(styles);
  //     }
  //   })
  // },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // console.log(' - - - Before Route Enter')
      vm.fetchData().then(data =>{
        // console.log('INFO: ',data.search)
        vm.info = data
        if (vm.info.custom_styles) {
          let styles = document.createElement('style');
          styles.type = 'text/css';
          styles.id = 'temp-styles';
          for (let d in vm.info.custom_styles) {
            if (!vm.info.custom_styles[d].value.hide) {
              styles.appendChild(document.createTextNode(vm.info.custom_styles[d].value.style));
            }
          }
          document.getElementsByTagName("head")[0].appendChild(styles);
        }
      })
    });
  },
  beforeRouteLeave (to, from, next){
    if (this.info.custom_styles) {
      let tempSty = document.getElementById('temp-styles');
      if (tempSty) {
        tempSty.remove();
      }
    }
    next();
  },
  mounted (){
    //  console.log('MOUNTED PAGE')
   
  },
  updated(){
    // console.log('UPDATED PAGE')
    // console.log(this.info)
  },
  methods:{
    fetchData(){
      // console.log('FETCH THE DATA')
      // console.log('This is the route: ', this.$route)

      var id = this.$route.meta.id
      if (typeof(this.$route.name) === "string") {
        if (this.$route.name.endsWith('-slide')) {
          // console.log('Get a different ID');
          // console.log(this.$route.matched[0].meta.id)
          id = this.$route.matched[0].meta.id
        }
      }

      return axios.get('/api/v2/pages/'+id).then(response => {
      //  console.log('RESPOSE: ' +JSON.stringify(response))
        return response.data
      })
    }
  }
}
</script>

<style scoped> 
  .header-spacer{
    height:75px;
    background: #333;
  }

</style>